import {Component, Inject, Input, OnInit} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {environment} from '../../../../environments/environment';
import {ConfService} from '../../../conf.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../../leftpanel/leftpanel.component';
import {AccountInfoService} from '../../../user/account-info.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatTableDataSource} from '@angular/material';
import {Router} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { ChangeDetectorRef } from '@angular/core'

export interface FromEmail {
  sender_email: string;
  sender_name: string;
  is_default: boolean;
}
@Component({
  selector: 'app-add-email-configuration-new',
  templateUrl: './add-email-configuration-new.component.html',
  styleUrls: ['./add-email-configuration-new.component.scss']
})

export class AddEmailConfigurationNewComponent implements OnInit {

    selectable = true;
  removable = true;
  addOnBlur = true;

  passphrase = environment.cipheringPhrase;
  iterationCount = 1000;
  keySize = 128 / 32;
  displayedColumns = ['selection', 'email', 'from', 'add'];
  dataSource: any;
  selectedElement: FromEmail;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(private dialog: MatDialog,
              private changeDetector: ChangeDetectorRef,

              @Inject(MAT_DIALOG_DATA) public data: any,
              public platform: LeftpanelComponent,
              public dialogRef: MatDialogRef<AddEmailConfigurationNewComponent>,
              public confPost: ConfService,
              public router: Router,
              public accountInfoService: AccountInfoService) {
    dialogRef.disableClose = true;


    this.dataSource = new MatTableDataSource(data['configuration']['fromEmailConfigurations']);

    for (const val of data['configuration']['fromEmailConfigurations']) {
      if (val.is_default) {
        this.selectedElement = val;
      }
    }
    
  }

  isValidPort(port: string): boolean {    
    const isValid = /^\d+$/.test(port) && +port >= 0 && +port <= 65535;
    return isValid;
  }

  isValidHost(host: string): boolean {
    const hostPattern = /^(?:(?!-)[A-Za-z0-9-]{1,63}(?<!-)\.?)+([A-Za-z]{2,}|(?:\d{1,3}\.){3}\d{1,3}|localhost)$/;
    return hostPattern.test(host);
  }

  isValidProtocol(protocol: string): boolean {
    const protocolPattern = /^(https?|ftp|ftps)?$/;
    return protocolPattern.test(protocol);
  }

  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }


  ngOnInit() {

  }

  add(event, data): void {
    const input = event.input;
    const value = event.value;
   
    if ((value || '').trim()) {
      data.push(value.trim());
    }

    if (input) {
      input.value = '';
    }
  }

  remove(val, data): void {
    const index = data.indexOf(val);

    if (index >= 0) {
      data.splice(index, 1);
    }
  }

  close() {
    this.dialogRef.close();
  }

  addEmail(event, emailArray) {
    event.preventDefault();
  
    const newEmail = {
      sender_email: '',
      sender_name: '',
      is_default: emailArray.length === 0,
    };
  
    emailArray.push(newEmail);  
    const updatedEmailArray = [...emailArray];  
    this.dataSource.data = updatedEmailArray;    
    this.changeDetector.detectChanges();
  }  
  

  removeEmail(emailArray, index) {
    const isDefault = emailArray[index].is_default;
    emailArray.splice(index, 1);
    if (emailArray.length > 0 && isDefault) {
      if (emailArray.length - 1 >= index) {
        emailArray[index].is_default = true;
      } else {
        emailArray[index - 1].is_default = true;
      }
    }
    this.dataSource.data = emailArray;
  }

  changeDefault(event, emailArray, index) {
    for (const val of emailArray) {
      val.is_default = false;
    }

    emailArray[index].is_default = true;

    this.dataSource.data = emailArray;
  }

  testConfiguration() {
    this.clearIncompleteFromAddresses();
    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
      maxWidth: '95vw',
      maxHeight: '60vh',
    });
    return new Promise((resolve, reject) => {
      this.confPost.testEmailServerConfigurations('3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc', this.data['configuration']).subscribe(response => {
        if (response && response.status && response.status === 200) {
          this.platform.openSnackBar('Test successful', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
        loaderDialog.close();
      }, error => {
        loaderDialog.close();
        this.platform.handleErrorGracefully(error, 'Test failed. Check the configuration, details');
      });
    });
  }

  clearIncompleteFromAddresses() {
    this.data['configuration']['fromEmailConfigurations'] = this.data['configuration']['fromEmailConfigurations'].filter(item => (item.sender_email && item.sender_email !== '' && item.sender_name && item.sender_name !== ''));
    let defaultFound = false;
    for (const val of this.data['configuration']['fromEmailConfigurations']) {
      if (val.is_default) {
        defaultFound = true;
        break;
      }
    }
    if (!defaultFound) {
      if (this.data['configuration']['fromEmailConfigurations'].length > 0) {
        this.data['configuration']['fromEmailConfigurations'][0].is_default = true;
      }
    }
    this.dataSource.data = this.data['configuration']['fromEmailConfigurations'];
  }

  async addConfiguration() {
    this.clearIncompleteFromAddresses();
            
    if (this.data['configuration']['server_name'] !== '' && this.data['configuration']['server_name'] !== null && this.data['configuration']['server_name'] !== undefined
        && this.data['configuration']['username'] !== '' && this.data['configuration']['username'] !== null && this.data['configuration']['username'] !== undefined
        && this.data['configuration']['password'] !== '' && this.data['configuration']['password'] !== null && this.data['configuration']['password'] !== undefined
        && this.data['configuration']['host'] !== '' && this.data['configuration']['host'] !== null && this.data['configuration']['host'] !== undefined && this.isValidHost(this.data['configuration']['host'])
        && this.data['configuration']['port'] !== null && this.data['configuration']['port'] !== undefined &&  this.isValidPort(this.data['configuration']['port'])
        && this.data['configuration']['protocol'] !== '' && this.data['configuration']['protocol'] !== null && this.data['configuration']['protocol'] !== undefined && this.isValidProtocol(this.data['configuration']['protocol'])  
        &&  this.data['configuration']['fromEmailConfigurations']
        .every(emailConfig => this.isValidEmail(emailConfig.sender_email)) ) {
      if (this.data['configuration']['fromEmailConfigurations'].length > 0) {
        const data = this.platform.adminSettingsData;
        if (data && data['body']) {
          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
          });

          const payload = {};

          const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          payload['shash'] = salt;
          payload['ralam'] = iv;
          const attributes = Object.keys(this.data['configuration']);
          for (const key of attributes) {
            if (key === 'username' || key === 'password' || key === 'host') {
              await this.platform.encryptAttribute(salt, iv, this.passphrase, this.data['configuration'][key], this.keySize, this.iterationCount).then(response => {
                payload[key] = response;
              });
            } else if (key === 'fromEmailConfigurations') {
              payload[key] = [];

              for (const email of this.data['configuration'][key]) {
                const attributes1 = Object.keys(email);
                const obj = JSON.parse(JSON.stringify(email));
                for (const key1 of attributes1) {
                  if (key1 === 'sender_name' || key1 === 'sender_email') {
                    await this.platform.encryptAttribute(salt, iv, this.passphrase, obj[key1], this.keySize, this.iterationCount).then(response => {
                      obj[key1] = response;
                    });
                  }
                }
                payload[key].push(obj);
              }
            } else {
              payload[key] = this.data['configuration'][key];
            }

          }

          let index = 0;
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined && env['name'] !== 'admin') {
              this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response => {
                if (response && response['body']) {
                  for (const env1 of response['body'][0]['environments']) {
                    if (env1 && env1 !== null && env1 !== undefined) {
                      let configFound = false;
                      env1['services'].filter(service => {
                        if (service.name === 'Email Configurations') {
                          configFound = true;
                          service['configurations'].push(payload);
                        }
                      });
                      if (!configFound) {
                        env1['services'].push({
                          'name': 'Email Configurations',
                          'type': 'emailConfigurations',
                          'configurations': [payload]
                        });
                      }
                    }
                  }


                  this.platform.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).then(resp1 => {
                    index += 1;
                    if (index === data['body'][0]['environments'].length) {
                      this.platform.openSnackBar('Email Configuration added successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                      });
                      loaderDialog.close();
                      this.dialogRef.close('success');
                    }
                  });
                }
              }, error => {
                loaderDialog.close();
              });
            }
          }
        }
      } else {
        this.platform.openSnackBar('Please configure at least one From Email Address.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.platform.openSnackBar('Please fill all the required attributes.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  async editConfiguration() {
    this.clearIncompleteFromAddresses();
    if (this.data['configuration']['server_name'] !== '' && this.data['configuration']['server_name'] !== null && this.data['configuration']['server_name'] !== undefined
        && this.data['configuration']['username'] !== '' && this.data['configuration']['username'] !== null && this.data['configuration']['username'] !== undefined
        && this.data['configuration']['password'] !== '' && this.data['configuration']['password'] !== null && this.data['configuration']['password'] !== undefined
        && this.data['configuration']['host'] !== '' && this.data['configuration']['host'] !== null && this.data['configuration']['host'] !== undefined  && this.isValidHost(this.data['configuration']['host'])
        && this.data['configuration']['port'] !== null && this.data['configuration']['port'] !== undefined &&  this.isValidPort(this.data['configuration']['port'])
        && this.data['configuration']['protocol'] !== '' && this.data['configuration']['protocol'] !== null && this.data['configuration']['protocol'] !== undefined  && this.isValidProtocol(this.data['configuration']['protocol']) 
        &&  this.data['configuration']['fromEmailConfigurations']
        .every(emailConfig => this.isValidEmail(emailConfig.sender_email))) {
      if (this.data['configuration']['fromEmailConfigurations'].length > 0) {
        const data = this.platform.adminSettingsData;
        if (data && data['body']) {
          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
          });

          const payload = {};

          const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
          payload['shash'] = salt;
          payload['ralam'] = iv;
          const attributes = Object.keys(this.data['configuration']);
          for (const key of attributes) {
            if (key === 'username' || key === 'password' || key === 'host') {
              await this.platform.encryptAttribute(salt, iv, this.passphrase, this.data['configuration'][key], this.keySize, this.iterationCount).then(response => {
                payload[key] = response;
              });
            } else if (key === 'fromEmailConfigurations') {
              payload[key] = [];

              for (const email of this.data['configuration'][key]) {
                const attributes1 = Object.keys(email);
                const obj = JSON.parse(JSON.stringify(email));
                for (const key1 of attributes1) {
                  if (key1 === 'sender_name' || key1 === 'sender_email') {
                    await this.platform.encryptAttribute(salt, iv, this.passphrase, obj[key1], this.keySize, this.iterationCount).then(response => {
                      obj[key1] = response;
                    });
                  }
                }
                payload[key].push(obj);
              }
            } else {
              payload[key] = this.data['configuration'][key];
            }

          }

          let index = 0;
          for (const env of data['body'][0]['environments']) {
            if (env && env !== null && env !== undefined && env['name'] !== 'admin') {
              this.confPost.getSettingsV2CRUD(env['name'], env['name'], false).subscribe(response => {
                if (response && response['body']) {
                  for (const env1 of response['body'][0]['environments']) {
                    if (env1 && env1 !== null && env1 !== undefined) {
                      env1['services'].filter(service => {
                        if (service.name === 'Email Configurations') {
                          service['configurations'][this.data['index']] = payload;
                        }
                      });
                    }
                  }
                  this.platform.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).then(resp1 => {
                    index += 1;
                    if (index === data['body'][0]['environments'].length) {
                      this.platform.openSnackBar('Email Configuration updated successfully', 'Success', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                      });
                      loaderDialog.close();
                      this.dialogRef.close('success');
                    }
                  });
                }
              }, error => {
                loaderDialog.close();
              });
            }
          }
        }
      } else {
        this.platform.openSnackBar('Please configure at least one From Email Address.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.platform.openSnackBar('Please fill all the required attributes.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }


}
